import { ServiceTypes } from 'constants/ServiceTypes';
import { ReactComponent as ColumnVisibilityIcon } from 'images/TopBar/columnsIcon.svg';
import { ReactComponent as FiltersIcon } from 'images/TopBar/filtersIcon.svg';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { ColumnsStore } from 'stores/ColumnsStore';
import { FilterStore } from 'stores/FilterStore';
import { BottomLabel, ControlBtn, ControlsWrapper, IconWrapper, SettingsLabelContainer } from './ControlsStyles';
import { ControlsTooltip } from './ControlsTooltip';

export const Controls = observer(() => {
  const columnsStore = useInjection<ColumnsStore>(ServiceTypes.ColumnsStore);
  const filterStore = useInjection<FilterStore>(ServiceTypes.FilterStore);

  const configuratorSettingHandler = () => {
    columnsStore.changeConfiguratorVisibility(true);
  };

  const filtersSettingHandler = () => {
    filterStore.changeConfiguratorVisibility(true);
  };

  const getFiltersTooltipTitle = () => {
    const count = filterStore.countFilters();

    if (count === 0) {
      return 'Filter';
    }
    if (count === 1) {
      return `Filter (1 filter applied)`;
    }
    return `Filter (${count} filters applied)`;
  };

  const getColumnsTooltipTitle = () => {
    const count = columnsStore.countHiddenColumns();

    if (count === 0) {
      return 'Manage columns';
    }
    if (count === 1) {
      return `Manage columns (1 column hidden)`;
    }
    return `Manage columns (${count} columns hidden)`;
  };

  return (
    <ControlsWrapper>
      <ControlsTooltip title={getFiltersTooltipTitle()}>
        <ControlBtn data-testid='filter-button' onClick={filtersSettingHandler}>
          <IconWrapper>
            <FiltersIcon />
          </IconWrapper>
          {filterStore.countFilters() > 0 && (
            <SettingsLabelContainer>
              <BottomLabel>({filterStore.countFilters()})</BottomLabel>
            </SettingsLabelContainer>
          )}
        </ControlBtn>
      </ControlsTooltip>
      <ControlsTooltip title={getColumnsTooltipTitle()}>
        <ControlBtn data-testid='columns-button' onClick={configuratorSettingHandler}>
          <IconWrapper>
            <ColumnVisibilityIcon />
          </IconWrapper>
          {columnsStore.countHiddenColumns() > 0 && (
            <SettingsLabelContainer>
              <BottomLabel>({columnsStore.countHiddenColumns()})</BottomLabel>
            </SettingsLabelContainer>
          )}
        </ControlBtn>
      </ControlsTooltip>
    </ControlsWrapper>
  );
});
